import {Component, Input} from "@angular/core";
import {Router} from "@angular/router";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-st-footer',
  templateUrl: './st-footer.component.html',
  styleUrls: ['./st-footer.component.scss'],
  standalone: false
})
export class StFooterComponent {

  @Input()
  idVal: string = 'banner-id';

}
